import { render, staticRenderFns } from "./CreateUserInfoBlock.vue?vue&type=template&id=3ec9ffac&scoped=true"
import script from "./CreateUserInfoBlock.vue?vue&type=script&lang=js"
export * from "./CreateUserInfoBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec9ffac",
  null
  
)

export default component.exports